export const trimText = (text: string) => text.length > 12 ? text.substring(0, 12) + "...": text
